import styled from '@mui/material/styles/styled'

export const FormContent = styled('div', {
  name: 'FormContent',
})(({ theme }) => ({
  flex: '1 1 auto',
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  paddingBottom: theme.spacing(22),
  [theme.breakpoints.down('lg')]: {
    order: 2,
  },
  paddingTop: theme.spacing(2),
  '@media (max-width: 1125px)': {
    paddingTop: theme.spacing(2),
  },
}))
